import { formatMoney, parseMoneyInput } from '@/lib/money'

interface Props {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  className?: string
}

export default function MoneyInput({ value, onChange, onBlur, placeholder, className }: Props) {
  return (
    <input
      type="text"
      inputMode="decimal"
      value={formatMoney(value ?? '')}
      onChange={(e) => onChange(parseMoneyInput(e.target.value))}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
    />
  )
}
